import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'

import {AxiosResponse }                                    from 'axios'
import { WaterTestStripInitialState, WaterTestStripState } from '../waterTestStrip.slice'
import { SippApi }                                         from '../../../services/SippExpress'
import { RequestConfig, WaterTestKitAnalysisApiBody } from '../../../types'


interface FetchWaterTestStripArguments {
  id: string,
  options?: RequestConfig
}


export const fetchWaterTestStripResultsAsync = createAsyncThunk<WaterTestKitAnalysisApiBody, FetchWaterTestStripArguments>(
  'waterTestStrip/fetchResults',
  async ({ options}, {rejectWithValue}) => {
    try {
      const response= await SippApi.fetchWaterTestStripAnalysis( options) as AxiosResponse<WaterTestKitAnalysisApiBody>

      return response.data
    } catch(error:any) {

      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
)

export const fetchWaterTestStripResultsAsyncBuilder = (
  builder: ActionReducerMapBuilder<WaterTestStripState>
) => {
  builder.addCase(fetchWaterTestStripResultsAsync.pending, (state) => {
    state.jobData = null;
    state.userData = null;

    state.loading = true;
    state.success = false;
    state.error = null;
  });

  builder.addCase(
    fetchWaterTestStripResultsAsync.fulfilled,
    (state, action: PayloadAction<WaterTestKitAnalysisApiBody>) => {
      const {result,user,requests, ...rest} = action.payload
      state.loading = false;
      state.success = true;
      state.jobData = {...rest}
      state.userData = user || null;

      state.requests = requests || WaterTestStripInitialState.requests
    }
  );

  builder.addCase(
    fetchWaterTestStripResultsAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    }
  );
};